import React from 'react';
import AdminLayout from '../../../../Components/CommonComponents/Layout/adminLayout';
import EventTypesFormContainer from '../../../../Containers/AdminContainer/EventTypes/EventTypesForm';
const EventTypesFormScreen = () => {
  return <EventTypesFormContainer />;
};

export default EventTypesFormScreen;
